{
  "name": "orval",
  "description": "A swagger client generator for typescript",
  "version": "7.21.0",
  "license": "MIT",
  "files": [
    "dist",
    "!dist/**/*.d.ts.map"
  ],
  "bin": "./dist/bin/orval.js",
  "type": "commonjs",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "default": "./dist/index.js"
    }
  },
  "engines": {
    "node": ">=22.18.0"
  },
  "keywords": [
    "rest",
    "client",
    "swagger",
    "open-api",
    "fetch",
    "data fetching",
    "code-generation",
    "angular",
    "react",
    "react-query",
    "svelte",
    "svelte-query",
    "vue",
    "vue-query",
    "msw",
    "mock",
    "axios",
    "vue-query",
    "vue",
    "swr",
    "zod",
    "hono"
  ],
  "author": {
    "name": "Victor Bury",
    "email": "victor@anymaniax.com"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/orval-labs/orval.git"
  },
  "scripts": {
    "build": "tsdown --config-loader unconfig",
    "dev": "tsdown --config-loader unconfig --watch src --onSuccess 'yarn generate-api'",
    "lint": "eslint .",
    "generate-api": "orval --config ../../samples/react-query/basic/orval.config.ts",
    "test": "tsc --noEmit && vitest",
    "clean": "rimraf .turbo dist",
    "nuke": "rimraf .turbo dist node_modules"
  },
  "devDependencies": {
    "@types/fs-extra": "^11.0.4",
    "@types/js-yaml": "^4.0.9",
    "@types/lodash.uniq": "^4.5.9",
    "eslint": "^9.38.0",
    "openapi-types": "^12.1.3",
    "rimraf": "^6.0.1",
    "tsdown": "^0.15.8",
    "typescript": "^5.9.3",
    "vitest": "^3.2.4"
  },
  "dependencies": {
    "@apidevtools/swagger-parser": "^12.1.0",
    "@commander-js/extra-typings": "^14.0.0",
    "@orval/angular": "workspace:*",
    "@orval/axios": "workspace:*",
    "@orval/core": "workspace:*",
    "@orval/fetch": "workspace:*",
    "@orval/hono": "workspace:*",
    "@orval/mcp": "workspace:*",
    "@orval/mock": "workspace:*",
    "@orval/query": "workspace:*",
    "@orval/swr": "workspace:*",
    "@orval/zod": "workspace:*",
    "chalk": "^4.1.2",
    "chokidar": "^4.0.3",
    "commander": "^14.0.1",
    "enquirer": "^2.4.1",
    "execa": "^5.1.1",
    "find-up": "5.0.0",
    "fs-extra": "^11.3.2",
    "jiti": "^2.6.1",
    "js-yaml": "4.1.1",
    "lodash.uniq": "^4.5.0",
    "openapi3-ts": "4.5.0",
    "string-argv": "^0.3.2",
    "tsconfck": "^2.1.2",
    "typedoc": "^0.28.14",
    "typedoc-plugin-coverage": "^4.0.2",
    "typedoc-plugin-markdown": "^4.9.0"
  }
}
